(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-3"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.login-dropdown-wrapper');
  if (!wrapper) return;

  const trigger = wrapper.querySelector('.login-trigger');
  const dropdown = wrapper.querySelector('.login-dropdown');

  // Toggle on click
  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    const isVisible = dropdown.style.display === 'block';
    dropdown.style.display = isVisible ? 'none' : 'block';
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
